import React from 'react';
import { useAdminSetupChecklist } from '../../hooks/useAdminSetupChecklist';
import { EXPAND_SECTION_EVENT } from '../common/CollapsibleSection';
import styles from './SetupChecklist.module.css';

export interface SetupChecklistProps {
  schoolId: number | string | null;
}

// Post-wizard nudge banner rendered at the top of AdminPanel.js's dashboard
// (see useAdminSetupChecklist.js for what counts as "still needs setup").
// Renders nothing while loading or once every tracked item is satisfied —
// same "disappear entirely, no dismiss state" behavior as
// SchoolSetupWizard.js itself.
const SetupChecklist: React.FC<SetupChecklistProps> = ({ schoolId }) => {
  const { items, loading } = useAdminSetupChecklist(schoolId);

  if (loading || items.length === 0) {
    return null;
  }

  const handleItemClick = (targetSectionId: string): void => {
    window.dispatchEvent(
      new CustomEvent(EXPAND_SECTION_EVENT, {
        detail: { id: targetSectionId },
      })
    );

    requestAnimationFrame(() => {
      document
        .getElementById(targetSectionId)
        ?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  };

  return (
    <div className={styles['setup-checklist']}>
      <h2>
        <span className={styles['section-icon']}>📋</span>
        Setup Checklist
      </h2>
      <ul className={styles['setup-checklist-list']}>
        {items.map((item) => (
          <li key={item.key}>
            <button
              type="button"
              className={styles['setup-checklist-item']}
              onClick={() => handleItemClick(item.targetSectionId)}
            >
              {item.label}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SetupChecklist;
